import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=b61f0e4a&scoped=true"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61f0e4a",
  null
  
)

export default component.exports